import angular from 'angular';

module.exports = angular.module('common.directives.render-once', [
])
.directive('renderOnce', function() {
  return {
    restrict: 'A',
    link: function (scope) {
      scope.$evalAsync(() => {
        scope.$destroy();
      });
    },
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/render-once.js
 **/